import {replace} from "react-router-redux";
import {ajax, addPath, removePath, validateEmail, signOutPath, redirectPage} from "../../common/utils";
import {LOG_IN_STATUS, FORGET_PASSWORD, SHOW_FACEBOOK_POPUP,
    RESET_PASSWORD_EMAIL_SENT, CHANGE_PASSWORD, RESET_STATUS, ENABLE_FB_BUTTON} from "../actionTypes";
import {setMemberData, setShowPassword} from "./memberDetailsActions";
import {isAddSubscription} from "./../common/subscriptionSummaryActions";
import {fetchingData, dataFetched, errorFetching} from "../common/fetchingActions";
import {JoinCreateAccountConstants, URLs, FetchingTypes, NO_COOKIE_LOGIN} from "../../common/constants";
import {setCreateAccountPage} from "../join/joinActions";
import {messageDataParser, setMessageData} from "../common/messagePageActions";

const OK_STATUSES = ['Ok', 'OkExistingForFarm'];
export function setStatus(status) {
    return {
        type: LOG_IN_STATUS,
        status: status
    };
}

export function setForgetPassword(isForgetPassword) {
    return {
        type: FORGET_PASSWORD,
        isForgetPassword: isForgetPassword
    }
}

export function setResetPasswordEmailSent(isResetPasswordEmailSent) {
    return {
        type: RESET_PASSWORD_EMAIL_SENT,
        isResetPasswordEmailSent: isResetPasswordEmailSent
    }
}

export function setShowCreateFBAccount(showCreateFBAccount, email) {
    return {
        type: SHOW_FACEBOOK_POPUP,
        showCreateFBAccount,
        email
    }
}

export function resetStatus() {
    return {
        type: RESET_STATUS
    }
}

export function setChangePassword(isNeedToChangePassword) {
    return {
        type: CHANGE_PASSWORD,
        isNeedToChangePassword: isNeedToChangePassword
    }
}

export function login() {
    return function(dispatch) {
        dispatch(replace(addPath('login')));
    }
}

export function loginWithEmail(email, password) {
    return function (dispatch, getState) {
        if(!dispatch(validateEmailInput(email))) {
            return;
        }
        if(!password || password === "") {
            dispatch(setStatus({status:'MissingPassword'}));
        } else {
            const fetchUrl = '/dispatcher/AuthenticationService.signin';
            const data = {farmKey: getState().staticData.farmKey, email: email, password: password};
            dispatch(fetchingData(FetchingTypes.LOGIN));
            return ajax(fetchUrl, data)
                .then(loginStatus => {
                    if (OK_STATUSES.includes(loginStatus.status) && !document.cookie.includes("farmigoMember")) {
                        dispatch(recordCookie(email));
                        throw new Error(NO_COOKIE_LOGIN);
                    }
                    dispatch(setMemberOnServerData(loginStatus));
                    dispatch(setStatus(loginStatus));
                    if (OK_STATUSES.includes(loginStatus.status)) {
                        if (window.location.pathname.endsWith('login')) {
                            window.location.reload();
                        } else if (window.location.pathname.startsWith('/' + URLs.JOIN)) {
                            dispatch(setShowPassword(false));
                            dispatch(setCreateAccountPage(JoinCreateAccountConstants.CONTACT_DETAILS, true));
                            let member = loginStatus.member;
                            dispatch(getSubscriptionStatus(member.key));
                        }
                    } else if (loginStatus.status === 'ChangePassword') {
                        dispatch(resetStatus());
                        dispatch(setChangePassword(true));
                    }
                    dispatch(dataFetched(FetchingTypes.LOGIN));
                })
                .catch(error => dispatch(errorFetching(error )));
        }
    }
}

function recordCookie(email) {
    return function (dispatch, getState) {
        const fetchUrl = '/dispatcher/WebStoreService.recordCookie';
        const data = {farmKey:getState().staticData.farmKey, email: email};
        return ajax(fetchUrl, data);
    }
}

function validateEmailInput(email) {
    return function(dispatch) {
        if (!email || email === "") {
            dispatch(setStatus({status: 'MissingEmail'}));
            return false;
        }
        else if (!validateEmail(email)) {
            dispatch(setStatus({status: 'InvalidEmail'}));
            return false;
        }
        return true;
    }
}

export function forgetPassword(email) {
    return function (dispatch, getState) {
        dispatch(fetchingData(FetchingTypes.LOGIN));
        if(!dispatch(validateEmailInput(email))) {
            dispatch(dataFetched());
            return;
        }
        const fetchUrl = '/dispatcher/MembersService.forgotPassword';
        const data = {farmKey:getState().staticData.farmKey, email: email};
        return ajax(fetchUrl, data)
            .then(status => {
                dispatch(setStatus(status));
                if(OK_STATUSES.includes(status.status)) {
                    dispatch(setResetPasswordEmailSent(true));
                }
            }).then(() => dispatch(dataFetched()));
    }
}

export function loginWithFacebook(email, facebookId, remember, sourceRequestUrl) {
    return function (dispatch, getState) {
        const fetchUrl = '/dispatcher/AuthenticationService.facebookAuthenticate';
        const data = {
            farmKey: getState().staticData.farmKey,
            email: email,
            facebookId: facebookId,
            remember: remember,
            sourceRequestUrl: sourceRequestUrl
        };
        dispatch(fetchingData(FetchingTypes.LOGIN));
        return ajax(fetchUrl, data)
            .then(loginStatus => {
                if (OK_STATUSES.includes(loginStatus.status)) {
                    dispatch(setStatus(loginStatus));
                    let member = loginStatus.member;
                    member['isFBLogin'] = true;
                    loginStatus.member = member;
                    dispatch(setMemberOnServerData(loginStatus));
                    if (window.location.pathname.endsWith('login')) {
                        window.location.reload();
                        dispatch(dataFetched());
                    } else if (window.location.pathname.startsWith('/' + URLs.JOIN)) {
                        dispatch(setShowPassword(false));
                        dispatch(getSubscriptionStatus(member.key));
                    }
                } else {
                    dispatch(setShowCreateFBAccount(true, email));
                    dispatch(dataFetched());
                }
            });
    }
}

export function logOut(memberKey) {
    return function (dispatch, getState) {
        const state = getState();
        const fetchUrl = '/dispatcher/AuthenticationService.signout';
        const data = {farmKey: state.staticData.farmKey, memberKey: memberKey ? memberKey : state.memberDetails.key};
        dispatch(fetchingData(FetchingTypes.LOG_OUT));
        return ajax(fetchUrl, data)
            .then(() => {
                if (isAddSubscription()) {
                    window.location.assign(redirectPage(URLs.ACCOUNT, state.staticData));
                } else {
                    dispatch(replace(signOutPath()));
                    window.location.reload();
                }
            });
    }
}

function setMemberOnServerData(json) {
    return function (dispatch) {
        if (OK_STATUSES.includes(json.status)) {
            dispatch(setMemberData(json.member));

        } else {
            dispatch(setMemberData(null));
        }
    }
}

export function activateFacebook(email, password, facebookAppId) {
    return function (dispatch) {
        dispatch(fetchingData(FetchingTypes.LOGIN));
        if (!dispatch(validateEmailInput(email))) {
            dispatch(dataFetched());
            return;
        }
        const fetchUrl = '/dispatcher/MembersService.activateFacebook';
        const data = {
            email: email,
            password: password,
            facebookId: facebookAppId, remember: true
        };
        return ajax(fetchUrl, data)
            .then(json => {
                json.facebookId = facebookAppId;
                dispatch(setStatus(json));
                dispatch(setMemberOnServerData(json));
                if (json === 'Ok' || OK_STATUSES.includes(json.status)) {
                    window.location.reload();
                }
            }).then(()=>dispatch(dataFetched()));
    }
}

export function changePassword(email, password, newPassword) {
    return function (dispatch, getState) {
        dispatch(fetchingData(FetchingTypes.LOGIN));
        if(!dispatch(validateEmailInput(email))) {
            dispatch(dataFetched());
            return;
        }
        const fetchUrl = '/dispatcher/AuthenticationService.changePassword';
        const data = {farmKey:getState().staticData.farmKey, email: email, password: password, newPassword: newPassword, remember: true};
        return ajax(fetchUrl, data)
            .then(json => {
                dispatch(setMemberOnServerData(json));
                return json;
            })
            .then(response => {
                dispatch(setStatus(response));
                if (OK_STATUSES.includes(response.status)) {
                    dispatch(setChangePassword(false));
                    if (window.location.pathname.endsWith('login')) {
                        window.location.reload();
                        dispatch(dataFetched());
                    } else if (window.location.pathname.startsWith('/' + URLs.JOIN)) {
                        dispatch(setShowPassword(false));
                        dispatch(getSubscriptionStatus(response.member.key));
                    }
                }
            })
    }
}
export function resetEmailSent() {
    return function(dispatch) {
        dispatch(resetStatus());
        dispatch(setForgetPassword(false));
        dispatch(setResetPasswordEmailSent(false));
    }
}

export function createFacebookMember(member) {
    return function (dispatch, getState) {
        const state = getState();
        const fetchUrl = '/dispatcher/AuthenticationService.createFacebookMember';
        const data = {
            farmKey:state.staticData.farmKey,
            email: member.email,
            firstName: member.firstName,
            lastName: member.lastName,
            facebookId: member.facebookId
        };
        dispatch(fetchingData(FetchingTypes.LOGIN));
        return ajax(fetchUrl, data)
            .then(json => {
                dispatch(setMemberOnServerData(json));
                return json;
            })
            .then(response => {
                if (OK_STATUSES.includes(response.status)) {
                    dispatch(getSubscriptionStatus(response.member.key, state.signupData.isGuestUser));
                    dispatch(setCreateAccountPage(JoinCreateAccountConstants.CONTACT_DETAILS));
                }
            }).then(()=> dispatch(dataFetched()));
    }
}

export function getSubscriptionStatus(memberKey, iGuestUser) {
    return function (dispatch, getState) {
        let state = getState();
        const fetchUrl = '/dispatcher/AuthenticationService.getSubscriptionStatus';
        const data = {
            seasonKey: state.staticData.seasonKey,
            memberKey: memberKey
        };
        dispatch(fetchingData(FetchingTypes.GET_STATUS));
        return ajax(fetchUrl, data)
            .then(json => {
                if(json === 'NoSubscription') {
                    dispatch(setCreateAccountPage(JoinCreateAccountConstants.CONTACT_DETAILS, true));
                    dispatch(dataFetched());
                    return;
                } else if (iGuestUser) {
                    const path = redirectPage(URLs.JOIN, state.staticData);
                    window.location.assign(path);
                }
                const messageData = messageDataParser({status:json}, {staticData: state.staticData});
                dispatch(setMessageData(messageData));
                dispatch(dataFetched());
            })
            .catch(error => {
                dispatch(errorFetching(error, {action:getSubscriptionStatus, args:[memberKey, iGuestUser]}));
            })
    }
}

export function showFBErrorMessage() {
    return (dispatch => {
        dispatch(errorFetching(new Error("Failed to connect to Facebook. Please try again.")));
    });
}

export function setEnableFbButton(enableFBButton){
    return {
        type: ENABLE_FB_BUTTON,
        enableFBButton
    }
}


// WEBPACK FOOTER //
// ./src/actions/login/logInActions.js